// TestIDs should be separated in case we will have automation testing
// Cypress will not recognize constants exported from .tsx
export const DropDownSelectTestIDs = {
  label: "dropdown-label",
};

export const DropDownSelectFieldTestIDs = {
  error: "dropdown-label-error",
};
